import { useCallback } from "react";
import { type NavigateOptions, useLocation, useNavigate } from "react-router-dom";

type NavigateWithSearchOptions = NavigateOptions & {
  search?: string;
};

export const useNavigateWithSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (pathname: string, options?: NavigateWithSearchOptions) => {
      const { search = location.search, ...navigateOptions } = options ?? {};
      navigate({ pathname, search }, navigateOptions);
    },
    [location.search, navigate],
  );
};
